import { useTranslation } from 'react-i18next';
import { SafeLink } from '../components/SafeLink.tsx';
import { useFormat, usePageTitle } from '../lib/format.ts';
import { usePwa } from '../lib/pwa.tsx';
import { useSignedIn } from '../lib/session.tsx';
import { Button } from '../components/kit.tsx';

/** The landing screen. Groups arrived with Phase 4; files, matching and the rest arrive with Phases 5–11. */
export function Home() {
  const { t, i18n } = useTranslation();
  const { view } = useSignedIn();
  const f = useFormat();
  const pwa = usePwa();
  usePageTitle(t('home.title'));
  const name = i18n.language !== 'th' && view.person.nameEn ? view.person.nameEn : view.person.nameTh;
  return (
    <div className="stack">
      <h1>{t('home.greeting', { name })}</h1>
      {view.ghost ? (
        <div className="alert alert--warning" role="status">
          <p>{t('home.ghost', { admin: view.ghost.admin.nameTh, subject: view.ghost.subject.nameTh })}</p>
        </div>
      ) : null}
      <section className="card" aria-labelledby="home-account">
        <h2 id="home-account">{t('home.account')}</h2>
        <dl className="facts">
          <dt>{t('home.kind')}</dt>
          <dd>{t(`home.kinds.${view.person.kind}`)}</dd>
          <dt>{t('home.roles')}</dt>
          <dd>{view.grants.length ? view.grants.map((g) => t(`home.roleNames.${g.role}`)).join(', ') : t('home.noRoles')}</dd>
          <dt>{t('home.mode')}</dt>
          <dd>{view.mode === 'shared' ? t('home.modeShared') : t('home.modeStandard')}</dd>
          <dt>{t('home.today')}</dt>
          <dd data-testid="today">{f.dateLong(Date.now())}</dd>
        </dl>
      </section>
      {view.person.kind === 'student' ? (
        <section className="card" aria-labelledby="home-group">
          <h2 id="home-group">{t('home.groupTitle')}</h2>
          <p>{t('home.groupBody')}</p>
          <SafeLink href="/group" className="btn">{t('home.groupLink')}</SafeLink>
        </section>
      ) : null}
      <section className="card" aria-labelledby="home-next">
        <h2 id="home-next">{t('home.comingTitle')}</h2>
        <p>{t('home.comingBody')}</p>
        <div className="row">
          <SafeLink href="/settings" className="btn btn--secondary">{t('shell.settings')}</SafeLink>
          {pwa.canInstall ? <Button variant="secondary" onClick={() => void pwa.install()}>{t('install.button')}</Button>
            : <SafeLink href="/install">{t('install.link')}</SafeLink>}
        </div>
      </section>
    </div>
  );
}
